import React from 'react';
import { Handshake, X } from 'lucide-react';
import { Button } from '../ui/button';

// Selo no modal do calendário: instalação vinculada a um projeto vendido (Portal de Vendas)
export const SalesProjectLinkField = ({ contractNumber, customerName, onClear, language = 'pt-BR' }) => {
  const pt = language === 'pt-BR';
  return (
    <div className="rounded-lg border border-teal-200 bg-teal-50/60 p-3 flex items-center gap-2 text-xs" data-testid="sales-project-link-field">
      <span className="inline-flex items-center gap-1 rounded-full bg-teal-600 text-white px-2 py-0.5 font-semibold shrink-0"><Handshake className="h-3 w-3" /> {pt ? 'Venda' : 'Sale'} · {contractNumber}</span>
      <span className="text-teal-900 truncate flex-1">{customerName} — {pt ? 'o projeto vendido vira "Instalação agendada" ao salvar' : 'the sold project becomes "Install scheduled" on save'}</span>
      {onClear && <Button type="button" variant="ghost" size="sm" className="h-7 px-2 text-teal-700 shrink-0" onClick={onClear} data-testid="sales-project-link-clear"><X className="h-3.5 w-3.5" /></Button>}
    </div>
  );
};

export default SalesProjectLinkField;
